module.exports = __webpack_public_path__ + "assets/font/MiSans-Thin-5fa28f55.woff2";